import { useState } from "react";
import useDialog from "./useDialog";

const useDialogWithIcoData = (initialOpen = false, initialId = null, modeView = "preview",  consolidatedIcoList = []) => {
  const [openDialog, handleOpenDialog, handleCloseDialog] =
    useDialog(initialOpen);
  const [id, setId] = useState(initialId);
  const [parentId, setParentId] = useState(undefined);
  const [copyId, setCopyId] = useState(undefined);
  const [selectedMode, setSelectedMode] = useState(modeView);
  const [consolidatedIcos, setConsolidatedIcos] = useState(consolidatedIcoList)


  const handleOpenDialogWithIcoData = (id, modeView, parentId = undefined,consolidatedIcoList = [], copyId = undefined) => {
    setId(id);
    setSelectedMode(modeView)
    setParentId(parentId)
    setConsolidatedIcos(consolidatedIcoList)
    setCopyId(copyId)
    handleOpenDialog();
  };

  const handleCloseDialogWithIcoData = () => {
    setId(null);
    setParentId(null)
    handleCloseDialog();
    setConsolidatedIcos([])
    setCopyId(null)
    setSelectedMode("preview")
  };

  return [openDialog, id, parentId, copyId, selectedMode, consolidatedIcos, handleOpenDialogWithIcoData, handleCloseDialogWithIcoData];
};

export default useDialogWithIcoData;
